<template>
  <div class="PMCardImageWrapper">
    <img :src="src" :alt="alt" width="400" height="559" :loading="loading" class="PMCardImage" :class="{canExpand}" :style="{ viewTransitionName }" @error="isLoadingError = true" @click="handleClick">
    <div class="Modal" v-if="canExpand" v-show="showExpansionModal" @click="showExpansionModal = false">
      <div class="container" @click.stop>
        <ModalClose class="close-icon" @click="showExpansionModal = false" />
        <img :src="src" :alt="`${alt} - 拡大`" :loading="loading" class="ExpandedPMCardImage" @error="isLoadingError = true">
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch, onBeforeUnmount } from 'vue'
import { ModalClose } from '@ka-nabellinc/ka-nabell-icons'

const DUMMY_IMAGE_URL = 'https://assets.ka-nabell.com/pokemon_dummy.png'

export default defineComponent({
  props: {
    alt: {
      type: String,
      default: ''
    },
    url: {
      type: String
    },
    size: {
      type: String as () => 'sm' | 'md',
      default: 'md'
    },
    loading: {
      type: String as () => 'eager' | 'lazy',
      default: 'eager'
    },
    canExpand: {
      type: Boolean,
      default: false
    },
    viewTransitionName: {
      type: String
    }
  },
  components: {
    ModalClose
  },
  setup(props) {
    const isLoadingError = ref(false)

    const src = computed(() => {
      if (isLoadingError.value) {
        return DUMMY_IMAGE_URL
      } else if (!props.url) {
        return DUMMY_IMAGE_URL
      } else if (props.size === 'sm') {
        return props.url.replace(/\.png$/, '.sm.jpg');
      } else {
        return props.url
      }
    })

    const showExpansionModal = ref<boolean>(false)

    // NOTE: 背景がスクロールされるのを防ぐために、モーダルが表示されている間はbodyのoverflowをhiddenにする
    watch(showExpansionModal, (newVal) => {
        // NOTE グローバル変数にdocumentがあるときのみ処理を実行
        if (typeof document === 'undefined') return;
        if (newVal) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      },{ immediate: true });

    // NOTE: アンマウント時にstyleをリセットする
    onBeforeUnmount(() => {
      document.body.style.overflow = '';
    });

    const handleClick = () => {
      if(!props.canExpand) return
      showExpansionModal.value = true
    }

    return {
      src,
      isLoadingError,
      showExpansionModal,
      handleClick
    }
  }
})
</script>

<style scoped>
.PMCardImageWrapper {
  width: 100%;
  aspect-ratio: 1 / 1.3968; /* Reference: https://docs.google.com/document/d/16oLURee9rZNXyVgpkvxBZ-VdsvWzuGp5-4NaZG1infk/edit#heading=h.a02r92ymr753 */
  overflow: hidden;
  position: relative;
}

.PMCardImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Modal {
  width: 100%;
  height: 100%;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--primitive-colors-neutral-black-300a);
}
  
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
  
.close-icon {
  position: absolute;
  top: -32px;
  right: 0;
  cursor: pointer;
  padding: 4px;
  box-sizing: content-box;
}

.close-icon > :deep(path) {
  fill: white;
}

.ExpandedPMCardImage {
  width: 320px;
  height: auto;
  object-fit: cover;
}

.canExpand {
  cursor: pointer;
}
</style>